const Icon = () => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6125 3.9375H0.625V5.35417H10.6125L8.41667 7.55L9.40833 8.54167L13.3042 4.64583L9.47917 0.75L8.4875 1.74167L10.6125 3.9375Z"
      fill="#575BFD"
    />
  </svg>
);

export default Icon;
